import React from "react";

const BookChapters = () => {
  return (
    <div className="textAlign">
        Currently no book chapters are available.
    {/* *****Uncomment this for adding content in Book Chapters***** */}
      {/* Singh JK,
      <font color="808000">
        "Chemical Modeling of Fluids near Surfaces in
        <em> Chemical Modeling</em>".
      </font>
      <font color="008080">
        vol. 8, 72-104, 2017, Royal Society of Chemistry
      </font>
      <br /> */}
    </div>
  );
};

export default BookChapters;
